import React from 'react';
import { PapiDeviation } from '@wix/da-papi-types';
import DeviationDumbView from '../../../../DeviationViews/Dumbo';
import TierStatisticsBar from '../../../../DeviationViews/Helper/StatisticsBar/TierStatisticsBar';

import s from './TierCardForExplorer.scss';

export interface Props {
  deviation: PapiDeviation;
  width: number;
  onClick: (deviation) => void;
}

const COVER_IMAGE_RATIO = 1.774;
const coverImagePadding = parseInt(s['padding']);

const TierCardForExplorer: React.FC<Props> = ({
  deviation,
  width,
  onClick,
}) => {
  const { title, coverImage, tier } = deviation;
  const { stats } = tier || {};

  if (!deviation.tier) {
    return null;
  }

  const onClickHandler = () => onClick(deviation);

  const coverImageWidth = width - 2 * coverImagePadding;
  const coverImageHeight = width / COVER_IMAGE_RATIO;

  return (
    <div className={s['root']} onClick={onClickHandler}>
      <div className={s['dumbo-wrapper']}>
        {coverImage ? (
          <DeviationDumbView
            className={s['dumbo']}
            deviation={coverImage}
            width={coverImageWidth}
            height={coverImageHeight}
          />
        ) : (
          <div
            className={s['placeholder-cover']}
            style={{ width: coverImageWidth, height: coverImageHeight }}
          />
        )}
      </div>
      <div className={s['title']}>{title}</div>
      <TierStatisticsBar className={s['stats']} stats={stats} />
    </div>
  );
};
TierCardForExplorer.displayName = 'TierCardForExplorer';

export default TierCardForExplorer;
